import type { RouteRecordRaw } from 'vue-router'
import { SettingIcon } from '@/components/icons'

export const SettingsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/settings',
    meta: { middleware: 'auth', requiresAuth: true },
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    children: [
      {
        path: '',
        name: 'settings',
        component: () => import('@/views/settings/index.vue'),
        meta: {
          breadcrumb: [{ text: 'تنظیمات', to: '/settings', icon: SettingIcon }]
        }
      },
      {
        path: 'blocked-users',
        name: 'blocked-users',
        component: () => import('@/views/settings/blocked-users.vue'),
        meta: {
          breadcrumb: [
            { text: 'تنظیمات', to: '/settings', icon: SettingIcon },
            { text: 'کاربران مسدودشده' }
          ]
        }
      },
      {
        path: 'password/:type',
        name: 'setting-password',
        component: () => import('@/views/settings/password.vue'),
        meta: {
          breadcrumb: [
            { text: 'تنظیمات', to: '/settings', icon: SettingIcon },
            { text: 'رمز عبور' }
          ]
        }
      }
    ]
  }
]
